'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _base = require('common/object/base');

var _base2 = _interopRequireDefault(_base);

var _messages = require('common/messages');

var _notifiers = require('common/notifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * BaseApplication is the main entry point into the application - it initializes everything from the root component, routing,
 * messaging systems, and so forth.
 */

function BaseApplication() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    _base2['default'].call(this, _extends({

        // collection of registered notifiers throughout the application
        notifierCollection: _notifiers.NotifierCollection.create()

    }, properties));

    this.notifierCollection.push(_notifiers.TypeNotifier.create(_messages.INITIALIZE, this._renderRootComponent.bind(this)));
}

_base2['default'].extend(BaseApplication, {

    /**
     */

    dispose: function dispose() {
        this._unmount();
    },


    /**
     */

    _unmount: function _unmount() {
        if (!this._mounted) return;
        this._mounted = false;
        _reactDom2['default'].unmountComponentAtNode(this.element);
    },


    /**
     * Dispatches an initialization message to the rest of the application
     */

    initialize: function initialize() {
        this.notifierCollection.notify(_messages.InitializeMessage.create());
        return this;
    },


    /**
     * called immediately after initialization. Renders the *root* component to the element property
     * defined in this application instance.
     */

    _renderRootComponent: function _renderRootComponent() {

        if (!this.element) return;

        this._unmount();
        this._mounted = true;
        _reactDom2['default'].render(this._createRootComponent(this._createRootComponentProps()), this.element);
    },


    /**
     */

    _createRootComponent: function _createRootComponent(props) {
        return _react2['default'].createElement(this.rootComponentClass, props);
    },


    /**
     */

    _createRootComponentProps: function _createRootComponentProps() {
        return _extends({}, this.rootComponentProps || {}, {
            app: this
        });
    }
});

module.exports = BaseApplication;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/application.jsx
 ** module id = 682
 ** module chunks = 0 1
 **/